import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'


import moment from "moment"
require('moment/locale/tr')



//import VueMoment from 'vue-moment'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import PrimeVue from 'primevue/config';

import VueClickAway from "vue3-click-away";

import VueSocketIO from 'vue-3-socket.io'
import SocketIO from 'socket.io-client'


import draggable from 'vuedraggable'

import drag from "v-drag"

//import VueVideoPlayer from '@videojs-player/vue'

//mixins
import {submission} from "./utilities/submission"
import {evaluation} from "./utilities/evaluation"
import {custom_columns_calculations} from "./utilities/custom_columns_calculations"
import {audit_functions} from "./utilities/audit_functions"

//mixins

//primevue
import Badge from 'primevue/badge';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';
import RadioButton from 'primevue/radiobutton';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Panel from 'primevue/panel';
import Toolbar from 'primevue/toolbar';
import SplitButton from 'primevue/splitbutton';
import Menu from 'primevue/menu';
import Tooltip from 'primevue/tooltip';
import BadgeDirective from 'primevue/badgedirective';
import Divider from 'primevue/divider';
import ProgressSpinner from 'primevue/progressspinner';
import Card from 'primevue/card';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';     //optional for column grouping
import Row from 'primevue/row'; 
import Chip from 'primevue/chip';
import MultiSelect from 'primevue/multiselect';
import FileUpload from 'primevue/fileupload';
import Avatar from 'primevue/avatar';
import AvatarGroup from 'primevue/avatargroup';
import TabMenu from 'primevue/tabmenu';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmPopup from 'primevue/confirmpopup';
import Dialog from 'primevue/dialog';
import Sidebar from 'primevue/sidebar';
import Toast from 'primevue/toast';
import InputSwitch from 'primevue/inputswitch';
import Calendar from 'primevue/calendar';
import InputNumber from 'primevue/inputnumber';
import Dropdown from 'primevue/dropdown';
import ScrollPanel from 'primevue/scrollpanel';
import Textarea from 'primevue/textarea';
import Tag from 'primevue/tag';
import Slider from 'primevue/slider';
import ProgressBar from 'primevue/progressbar';
import Editor from 'primevue/editor';
import Listbox from 'primevue/listbox';
import ColorPicker from 'primevue/colorpicker';
import Knob from 'primevue/knob';
import Fieldset from 'primevue/fieldset';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Chart from 'primevue/chart';
import Skeleton from 'primevue/skeleton';
import SelectButton from 'primevue/selectbutton';
import Menubar from 'primevue/menubar';
import CascadeSelect from 'primevue/cascadeselect';
import VirtualScroller from 'primevue/virtualscroller';
import TreeSelect from 'primevue/treeselect';
import Message from 'primevue/message';
import AutoComplete from 'primevue/autocomplete';
import Tree from 'primevue/tree';
import TriStateCheckbox from 'primevue/tristatecheckbox';

//primevue

//pagecomponents
import Topbar from "./components/pagecomponents/Topbar"
import TicketModal from "./components/pagecomponents/TicketModal"
import NotificationsModal from "./components/pagecomponents/NotificationsModal"
import SearchModal from "./components/pagecomponents/SearchModal"
import leftSidebar from "./components/pagecomponents/leftSidebar"
import ContentOverlay from "./components/pagecomponents/ContentOverlay"
import FrameOverlay from "./components/pagecomponents/FrameOverlay"
import ContentHeader from "./components/pagecomponents/ContentHeader"
import CollapsableFlowCard from "./components/pagecomponents/CollapsableFlowCard"
import VerificationDataTransferModal from "./components/pagecomponents/VerificationDataTransferModal"
import SupplierCustomAttributesModal from "./components/pagecomponents/SupplierCustomAttributesModal"
import SupplierCertificateUploader from "./components/pagecomponents/SupplierCertificateUploader"
import CollapsePanel from "./components/pagecomponents/CollapsePanel"
import ProjectCard from "./components/pagecomponents/ProjectCard"
import TabNavigation from "./components/pagecomponents/TabNavigation"
import TabNavigationItem from "./components/pagecomponents/TabNavigationItem"
import DeleteDialog from "./components/pagecomponents/DeleteDialog"
import ContentTable from "./components/pagecomponents/ContentTable"
import ContentTableFilterable from "./components/pagecomponents/ContentTableFilterable"
import OffcanvasMenu from "./components/pagecomponents/OffcanvasMenu"
import Notifications from "./components/pagecomponents/Notifications"
import UserDropDown from "./components/pagecomponents/UserDropDown"
import UserNotifications from "./components/pagecomponents/UserNotifications"
import ScheduleDetailsModal from "./components/pagecomponents/ScheduleDetailsModal"
import SortableArray from "./components/pagecomponents/SortableArray"
import ContentTableForAttributes from "./components/pagecomponents/ContentTableForAttributes"
import LineItem from "./components/pagecomponents/LineItem"
import SupplierUploadDialog from "./components/pagecomponents/SupplierUploadDialog"
import SuppliersTable from "./components/pagecomponents/SuppliersTable"
import SortableTable from "./components/pagecomponents/SortableTable"
import SortableTableExtended from "./components/pagecomponents/SortableTableExtended"
import SortableAuditDays from "./components/pagecomponents/SortableAuditDays"
import MailTemplateModal from "./components/pagecomponents/MailTemplateModal"
import TicketMessage from "./components/pagecomponents/TicketMessage"
import TicketConversation from "./components/pagecomponents/TicketConversation"
import DraggableContentTable from "./components/pagecomponents/DraggableContentTable"
import ContentTableExtended from "./components/pagecomponents/ContentTableExtended"
import SearchArea from "./components/pagecomponents/SearchArea"
import ItemSidebar from "./components/pagecomponents/ItemSidebar"
import AuditorCalendar from "./components/pagecomponents/AuditorCalendar"
import ReportProgersssBar from "./components/pagecomponents/ReportProgersssBar"
import NonconformityPanel from "./components/pagecomponents/NonconformityPanel"
import ActionPlanPanel from "./components/pagecomponents/ActionPlanPanel"
import ActionPlanAdminPanel from "./components/pagecomponents/ActionPlanAdminPanel"
import CustomScoreDisplay from "./components/pagecomponents/CustomScoreDisplay"

import NonconformityPanelForAdmin from "./components/pagecomponents/NonconformityPanelForAdmin"

import NonconformityClosurePanel from "./components/pagecomponents/NonconformityClosurePanel"
import CorrectionRequests from "./components/pagecomponents/CorrectionRequests"
import AuditCalendar from "./components/pagecomponents/AuditCalendar"
import AuditorAuditCalendar from "./components/pagecomponents/AuditorAuditCalendar"
import OpenNonconformityRequests from "./components/pagecomponents/OpenNonconformityRequests"
import SupplierNotificationDashboardWidget from "./components/pagecomponents/SupplierNotificationDashboardWidget"
import SupplierDashboardProjectWidget from "./components/pagecomponents/SupplierDashboardProjectWidget"
import SupplierDashboardProjectWrap from "./components/pagecomponents/SupplierDashboardProjectWrap"
import PlannerSpecificColumnDialog from "./components/pagecomponents/PlannerSpecificColumnDialog"
import PlannerSpecificFiltersDialog from "./components/pagecomponents/PlannerSpecificFiltersDialog"
import PlannerTable from "./components/pagecomponents/PlannerTable"
import CustomAttributeGroupLine from "./components/pagecomponents/CustomAttributeGroupLine"
import CustomAttributeLine from "./components/pagecomponents/CustomAttributeLine"
import BrandVisualGroupLine from "./components/pagecomponents/BrandVisualGroupLine"
import BrandReportLine from "./components/pagecomponents/BrandReportLine"
import CustomSwitch from "./components/pagecomponents/CustomSwitch"
import SuppliersCustomAttributeFilter from "./components/pagecomponents/SuppliersCustomAttributeFilter"



//pagecomponents
//formcomponents
import InputTextValidate from "./components/formcomponents/InputTextValidate"
import InputTextAreaValidate from "./components/formcomponents/InputTextAreaValidate"
import ClickEditInputTextArea from "./components/formcomponents/ClickEditInputTextArea"
import ClickEditUpload from "./components/formcomponents/ClickEditUpload"
import ClickEditUploadDeletable from "./components/formcomponents/ClickEditUploadDeletable"
import ClickEditInputRichTextArea from "./components/formcomponents/ClickEditInputRichTextArea"
import InputMultiSelectValidate from "./components/formcomponents/InputMultiSelectValidate"
import InputSelectValidate from "./components/formcomponents/InputSelectValidate"
import ClickEditInputText from "./components/formcomponents/ClickEditInputText"
import ClickEditMap from "./components/formcomponents/ClickEditMap"
import ClickEditCategory from "./components/formcomponents/ClickEditCategory"
import ClickEditCascadeCategory from "./components/formcomponents/ClickEditCascadeCategory"
import ClickEditColorPicker from "./components/formcomponents/ClickEditColorPicker"
import InputSwitchValidate from "./components/formcomponents/InputSwitchValidate"
import InputColorPickerValidate from "./components/formcomponents/InputColorPickerValidate"
import InputCalendarValidate from "./components/formcomponents/InputCalendarValidate"
import InputNumberValidate from "./components/formcomponents/InputNumberValidate"
import ClickEditSwitch from "./components/formcomponents/ClickEditSwitch"
import ClickEditNumber from "./components/formcomponents/ClickEditNumber"
import ClickEditCalendar from "./components/formcomponents/ClickEditCalendar"
import ClickAddInputText from "./components/formcomponents/ClickAddInputText"
import ClickEditSelect from "./components/formcomponents/ClickEditSelect"
import ClickEditSelectOptions from "./components/formcomponents/ClickEditSelectOptions"
import ClickEditSelectTags from "./components/formcomponents/ClickEditSelectTags"
import InputChipsValidate from "./components/formcomponents/InputChipsValidate"
import ClickEditMultiSelect from "./components/formcomponents/ClickEditMultiSelect"
import AuditorQuestionlistLine from "./components/formcomponents/AuditorQuestionlistLine"
import ClickAddSelect from "./components/formcomponents/ClickAddSelect"
import ClickEditSlider from "./components/formcomponents/ClickEditSlider"
//formcomponents

//evaluationcomponents
import EvaluationSectionSelector from "./components/evaluationcomponents/EvaluationSectionSelector"
import QuizProgress from "./components/evaluationcomponents/QuizProgress"
import CustomInputfield from "./components/evaluationcomponents/CustomInputfield"
import QuizStatusChanger from "./components/evaluationcomponents/QuizStatusChanger"
import NullReasonModal from "./components/evaluationcomponents/NullReasonModal"
import EvidenceModal from "./components/evaluationcomponents/EvidenceModal"
import VideoPlayer from "./components/evaluationcomponents/VideoPlayer"
import FlowProcess from "./components/evaluationcomponents/FlowProcess"
import QuizFinishModal from "./components/evaluationcomponents/QuizFinishModal"
import CorrectionRequestModal from "./components/evaluationcomponents/CorrectionRequestModal"
import QuestionlistPreviewSectionSelector from "./components/evaluationcomponents/QuestionlistPreviewSectionSelector"
import QuizPreviewProgress from "./components/evaluationcomponents/QuizPreviewProgress"




//evaluationcomponents
//auditcomponents
import AuditSectionSelector from "./components/auditcomponents/AuditSectionSelector"
import AuditViewSwitch from "./components/auditcomponents/AuditViewSwitch"
import SectionInputfields from "./components/auditcomponents/SectionInputfields"
import CustomAuditInputfield from "./components/auditcomponents/CustomAuditInputfield"


import AuditEvidenceModal from "./components/auditcomponents/AuditEvidenceModal"
import AuditNullReasonModal from "./components/auditcomponents/AuditNullReasonModal"
import AuditQuizFinishModal from "./components/auditcomponents/AuditQuizFinishModal"
import AuditQuizStatusChanger from "./components/auditcomponents/AuditQuizStatusChanger"
import ListviewQuestionlist from "./components/auditcomponents/ListviewQuestionlist"
import ListviewQuestionlistSection from "./components/auditcomponents/ListviewQuestionlistSection"

//auditcomponents


//calculationcomponents


import CalculationRoot from "./components/calculationcomponents/CalculationRoot"
import QuestionlistCalculationRoot from "./components/questionlistcalculationcomponents/QuestionlistCalculationRoot"
import AnalyticsCalculationRoot from "./components/analyticcomponents/AnalyticsCalculationRoot"
import AnalyticsListOutput from "./components/analyticcomponents/AnalyticsListOutput"
import AnalyticsGroupOutput from "./components/analyticcomponents/AnalyticsGroupOutput"

//calculationcomponents


import BarChart from "./components/brandcharts/BarChart"
import LineChart from "./components/brandcharts/LineChart"
import PieChart from "./components/brandcharts/PieChart"

//import "primevue/resources/themes/saga-blue/theme.css"       //theme
import "primevue/resources/primevue.min.css"                //core css
import "primeicons/primeicons.css"                     //icons
import "primeflex/primeflex.css" 
import "./assets/theme.css"   
import "./assets/main.css" 


import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

const app = createApp(App)
app.use(store)
app.use(router)
//app.use(VueLodash)
app.use(PrimeVue, {inputStyle: 'filled',ripple: true})
app.use(VueClickAway)
app.use(ConfirmationService);
app.use(ToastService);
app.use(drag, {
  eventClass: {
    down: "is-pressed",
    move: "is-moving"
  }
});
//app.use(VueVideoPlayer)


const io = new VueSocketIO({
    debug: false,
    connection: SocketIO(process.env.VUE_APP_APP_SOCKET), //options object is Optional
    vuex: {
      store,
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_"
    }
  })
app.use(io);
app.config.globalProperties.sockets = io






//mixins
app.mixin(submission);
app.mixin(evaluation);
app.mixin(custom_columns_calculations);
app.mixin(audit_functions);

//mixins
app.component('draggable', draggable);


//primevue
app.component('Badge', Badge);
app.component('Button', Button);
app.component('InputText', InputText);
app.component('Checkbox', Checkbox);
app.component('RadioButton', RadioButton);
app.component('Accordion', Accordion);
app.component('AccordionTab', AccordionTab);
app.component('Panel', Panel);
app.component('Toolbar', Toolbar);
app.component('SplitButton', SplitButton);
app.component('Menu', Menu);
app.directive('tooltip', Tooltip);
app.directive('badge', BadgeDirective);
app.component('Divider', Divider);
app.component('ProgressSpinner', ProgressSpinner);
app.component('Card', Card);
app.component('DataTable', DataTable);
app.component('Column', Column);
app.component('ColumnGroup', ColumnGroup);
app.component('Row', Row);
app.component('Chip', Chip);
app.component('MultiSelect', MultiSelect);
app.component('FileUpload', FileUpload);
app.component('Avatar', Avatar);
app.component('AvatarGroup', AvatarGroup);
app.component('TabMenu', TabMenu);
app.component('ConfirmDialog', ConfirmDialog);
app.component('ConfirmPopup', ConfirmPopup);
app.component('Dialog', Dialog);
app.component('Sidebar', Sidebar);
app.component('InputSwitch', InputSwitch);
app.component('Toast', Toast);
app.component('Calendar', Calendar);
app.component('InputNumber', InputNumber);
app.component('Dropdown', Dropdown);
app.component('ScrollPanel', ScrollPanel);
app.component('Textarea', Textarea);
app.component('Tag', Tag);
app.component('Slider', Slider);
app.component('ProgressBar', ProgressBar);
app.component('Editor', Editor);
app.component('Listbox', Listbox);
app.component('ColorPicker', ColorPicker);
app.component('Knob', Knob);
app.component('Fieldset', Fieldset);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('Chart', Chart);
app.component('Skeleton', Skeleton);
app.component('SelectButton', SelectButton);
app.component('Menubar', Menubar);
app.component('CascadeSelect', CascadeSelect);
app.component('VirtualScroller', VirtualScroller);
app.component('TreeSelect', TreeSelect);
app.component('Message', Message);
app.component('AutoComplete', AutoComplete);
app.component('Tree', Tree);
app.component('TriStateCheckbox', TriStateCheckbox);

//primevue

//pagecomponents
app.component('Topbar', Topbar);
app.component('TicketModal', TicketModal);
app.component('NotificationsModal', NotificationsModal);
app.component('SearchModal', SearchModal);
app.component('leftSidebar', leftSidebar);
app.component('ContentOverlay', ContentOverlay);
app.component('OffcanvasMenu', OffcanvasMenu);
app.component('Notifications', Notifications);
app.component('FrameOverlay', FrameOverlay);
app.component('ContentHeader', ContentHeader);
app.component('CollapsableFlowCard', CollapsableFlowCard);
app.component('VerificationDataTransferModal', VerificationDataTransferModal);
app.component('SupplierCustomAttributesModal', SupplierCustomAttributesModal);
app.component('SupplierCertificateUploader', SupplierCertificateUploader);
app.component('CollapsePanel', CollapsePanel);
app.component('ProjectCard', ProjectCard);
app.component('TabNavigation', TabNavigation);
app.component('TabNavigationItem', TabNavigationItem);
app.component('DeleteDialog', DeleteDialog);
app.component('ContentTable', ContentTable);
app.component('ContentTableExtended', ContentTableExtended);
app.component('ContentTableFilterable', ContentTableFilterable);
app.component('InputTextValidate', InputTextValidate);
app.component('InputTextAreaValidate', InputTextAreaValidate);
app.component('ClickEditInputTextArea', ClickEditInputTextArea);
app.component('ClickEditUpload', ClickEditUpload);
app.component('ClickEditUploadDeletable', ClickEditUploadDeletable);
app.component('ClickEditInputRichTextArea', ClickEditInputRichTextArea);
app.component('InputMultiSelectValidate', InputMultiSelectValidate);
app.component('InputSelectValidate', InputSelectValidate);
app.component('ClickEditInputText', ClickEditInputText);
app.component('ClickEditMap', ClickEditMap);
app.component('ClickEditCategory', ClickEditCategory);
app.component('ClickEditCascadeCategory', ClickEditCascadeCategory);
app.component('ClickEditColorPicker', ClickEditColorPicker);
app.component('InputSwitchValidate', InputSwitchValidate);
app.component('InputColorPickerValidate', InputColorPickerValidate);
app.component('InputCalendarValidate', InputCalendarValidate);
app.component('InputNumberValidate', InputNumberValidate);
app.component('ClickEditSwitch', ClickEditSwitch);
app.component('ClickEditNumber', ClickEditNumber);
app.component('ClickEditCalendar', ClickEditCalendar);
app.component('ClickAddInputText', ClickAddInputText);
app.component('UserDropDown', UserDropDown);
app.component('UserNotifications', UserNotifications);
app.component('ScheduleDetailsModal', ScheduleDetailsModal);
app.component('ClickEditSelect', ClickEditSelect);
app.component('ClickEditSelectOptions', ClickEditSelectOptions);
app.component('ClickEditSelectTags', ClickEditSelectTags);
app.component('SortableArray', SortableArray);
app.component('InputChipsValidate', InputChipsValidate);
app.component('ContentTableForAttributes', ContentTableForAttributes);
app.component('LineItem', LineItem);
app.component('ClickEditMultiSelect', ClickEditMultiSelect);
app.component('SupplierUploadDialog', SupplierUploadDialog);
app.component('SuppliersTable', SuppliersTable);
app.component('SortableTable', SortableTable);
app.component('SortableTableExtended', SortableTableExtended);
app.component('SortableAuditDays', SortableAuditDays);
app.component('AuditorQuestionlistLine', AuditorQuestionlistLine);
app.component('ClickAddSelect', ClickAddSelect);
app.component('ClickEditSlider', ClickEditSlider);
app.component('EvaluationSectionSelector', EvaluationSectionSelector);
app.component('QuizProgress', QuizProgress);
app.component('QuizPreviewProgress', QuizPreviewProgress);
app.component('CustomInputfield', CustomInputfield);
app.component('QuizStatusChanger', QuizStatusChanger);
app.component('NullReasonModal', NullReasonModal);
app.component('EvidenceModal', EvidenceModal);
app.component('VideoPlayer', VideoPlayer);
app.component('FlowProcess', FlowProcess);
app.component('QuizFinishModal', QuizFinishModal);
app.component('CorrectionRequestModal', CorrectionRequestModal);
app.component('QuestionlistPreviewSectionSelector', QuestionlistPreviewSectionSelector);

app.component('MailTemplateModal', MailTemplateModal);
app.component('DraggableContentTable', DraggableContentTable);
app.component('SearchArea', SearchArea);
app.component('ItemSidebar', ItemSidebar);
app.component('AuditorCalendar', AuditorCalendar);
app.component('ReportProgersssBar', ReportProgersssBar);
app.component('NonconformityPanel', NonconformityPanel);
app.component('ActionPlanPanel', ActionPlanPanel);
app.component('ActionPlanAdminPanel', ActionPlanAdminPanel);
app.component('CustomScoreDisplay', CustomScoreDisplay);

app.component('NonconformityPanelForAdmin', NonconformityPanelForAdmin);

app.component('NonconformityClosurePanel', NonconformityClosurePanel);
app.component('CorrectionRequests', CorrectionRequests);
app.component('AuditCalendar', AuditCalendar);
app.component('AuditorAuditCalendar', AuditorAuditCalendar);
app.component('OpenNonconformityRequests', OpenNonconformityRequests);
app.component('SupplierNotificationDashboardWidget', SupplierNotificationDashboardWidget);
app.component('SupplierDashboardProjectWidget', SupplierDashboardProjectWidget);
app.component('SupplierDashboardProjectWrap', SupplierDashboardProjectWrap);
app.component('PlannerSpecificColumnDialog', PlannerSpecificColumnDialog);
app.component('PlannerSpecificFiltersDialog', PlannerSpecificFiltersDialog);
app.component('PlannerTable', PlannerTable);
app.component('CustomAttributeGroupLine', CustomAttributeGroupLine);
app.component('CustomAttributeLine', CustomAttributeLine);
app.component('BrandVisualGroupLine', BrandVisualGroupLine);
app.component('BrandReportLine', BrandReportLine);
app.component('CustomSwitch', CustomSwitch);
app.component('SuppliersCustomAttributeFilter', SuppliersCustomAttributeFilter);

app.component('CalculationRoot', CalculationRoot);
app.component('QuestionlistCalculationRoot', QuestionlistCalculationRoot);
app.component('AnalyticsCalculationRoot', AnalyticsCalculationRoot);
app.component('AnalyticsListOutput', AnalyticsListOutput);
app.component('AnalyticsGroupOutput', AnalyticsGroupOutput);
app.component('TicketMessage', TicketMessage);
app.component('TicketConversation', TicketConversation);
//pagecomponents

//audit components
app.component('AuditSectionSelector', AuditSectionSelector);
app.component('AuditViewSwitch', AuditViewSwitch);
app.component('SectionInputfields', SectionInputfields);
app.component('CustomAuditInputfield', CustomAuditInputfield);
app.component('AuditEvidenceModal', AuditEvidenceModal);
app.component('AuditNullReasonModal', AuditNullReasonModal);
app.component('AuditQuizFinishModal', AuditQuizFinishModal);
app.component('AuditQuizStatusChanger', AuditQuizStatusChanger);
app.component('ListviewQuestionlist', ListviewQuestionlist);
app.component('ListviewQuestionlistSection', ListviewQuestionlistSection);



app.component('BarChart', BarChart);
app.component('LineChart', LineChart);
app.component('PieChart', PieChart);

//audit components

app.component('VueDatePicker', VueDatePicker);

app.config.globalProperties.$filters = {
  	momentFormat: function (value,format) {
    if (!value) return ''
        let date = moment(value).format(format)
        return date
  	},

  	numberformat: function (value) {
      if (value || value ===0)
      {
        let number = value.toLocaleString('tr-TR', { maximumFractionDigits: 8 });
        return number
      }
      else
      {
        return ""
      }        
    },
    numberformatwithdigits: function (value,digits) {
      if (value || value ===0)
      {
        let number = value.toLocaleString('tr-TR', { maximumFractionDigits: digits });
        return number
      }
      else
      {
        return ""
      }        
    },

    numberformatShort: function (value) {
      if (value || value ===0)
      {
        let number = value.toLocaleString('tr-TR', { maximumFractionDigits: 5 });
        return number
      }
      else
      {
        return ""
      }        
    },

  	videoduration: function (duration) {
    if (!duration) return ''
    	if(duration<3600)
    	{
    		return moment.utc(duration*1000).format('mm:ss');
    	}
    	else
    	{
    		return moment.utc(duration*1000).format('HH:mm:ss');
    	}
    	
       


      
  	},
  booleanView: function (value) {
	    if (value===0) 
      {
        return '<span class="material-symbols-outlined text-red-500 md-24">do_not_disturb_on</span>';
      }
      else if (value===1) 
      {
        return '<span class="material-symbols-outlined  text-green-500 md-24">check_circle</span>';
      }
      else if (value===false) 
      {
        return '<span class="material-symbols-outlined text-red-500 md-24">do_not_disturb_on</span>';
      }
      else if (value===true) 
      {
        return '<span class="material-symbols-outlined  text-green-500 md-24">check_circle</span>';
      }
	    else
	    {
	    	return '<span class="material-symbols-outlined text-blue-400 md-24">radio_button_unchecked</span>';
	    }
	},
	sidebartextadjust:function(value)
	{
		let spaced = value.replace(/\//g, '/ ');

		return spaced

	}

}






app.mount('#app')

export default app
/*
setTimeout(()=>{
	console.log("fire")
app.mount('#app')	
},3000)
*/

